/**
 * Ryan O'Dowd
 * 2024-11-20
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors}) => {
  return {
    container: {
      padding: globalScale * 8,
      minWidth: globalScale * 40,
      minHeight: globalScale * 40,
    },
    icon: {
      color: colors.white,
      fontSize: globalScale * 24,
    },
  };
};

export default getStyles;
